import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const navLinks = [
    { label: "首页", href: "/" },
    { label: "热门推荐", href: "/category/recommend" },
    { label: "电影", href: "/category/movie" },
    { label: "电视剧", href: "/category/tv-series" },
    { label: "综艺", href: "/category/variety" },
    { label: "动漫", href: "/category/anime" },
    { label: "关于我们", href: "/about" },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? "bg-background-50/95 backdrop-blur-md shadow-sm border-b border-background-200/50"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1280px] mx-auto flex items-center justify-between px-4 md:px-6 h-16">
        <Link to="/" className="flex items-center gap-2 flex-shrink-0">
          <h1 className={`font-heading text-xl font-bold transition-colors ${isScrolled ? "text-primary-600" : "text-white"}`}>
            17.c 起草
          </h1>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === link.href
                  ? isScrolled
                    ? "text-primary-600 bg-primary-50"
                    : "text-white bg-white/20"
                  : isScrolled
                    ? "text-foreground-700 hover:text-primary-600 hover:bg-background-200/70"
                    : "text-white/80 hover:text-white hover:bg-white/15"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/category/recommend"
            className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-all ${
              isScrolled
                ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                : "bg-white/20 text-white hover:bg-white/30 backdrop-blur-sm"
            }`}
          >
            <i className="ri-play-circle-line mr-1"></i>开始观看
          </Link>
        </div>

        <button
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer transition-colors ${
            isScrolled ? "text-foreground-800 hover:bg-background-200" : "text-white hover:bg-white/15"
          }`}
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 shadow-lg">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`px-3 py-2.5 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === link.href
                    ? "text-primary-600 bg-primary-50"
                    : "text-foreground-700 hover:text-primary-600 hover:bg-background-200/70"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/category/recommend"
              className="mt-2 px-4 py-2.5 rounded-full text-sm font-medium text-center bg-primary-500 text-background-50 hover:bg-primary-600 cursor-pointer whitespace-nowrap transition-colors"
            >
              <i className="ri-play-circle-line mr-1"></i>开始观看
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}